import { Button, Container } from '@cluey/cluey-components';
import classNames from 'classnames';
import { useHistory } from 'react-router';

import { CheckIcon } from '../../../../icons';
import { PATH_HUB_SESSIONS_PAGE } from '../../../legacy/pagePath';
import { Session } from '../../../legacy/types';
import { formatSessionSchedule } from '../helpers';
import { MAX_SESSIONS_FOR_DISCOUNT } from './SummerDiscountOffer';

const SummerDiscountOfferSuccess = ({ sessionsToApplyDiscountTo }: { sessionsToApplyDiscountTo: Session[] }) => {
  const history = useHistory();

  const sessionsToDisplay = sessionsToApplyDiscountTo.slice(0, MAX_SESSIONS_FOR_DISCOUNT);

  return (
    <Container className="flex flex-col items-center gap-9 px-4 py-7 md:py-8 lg:mb-0">
      <div className={classNames('mt-10 flex flex-col items-center gap-2')}>
        <div className="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-green-4">
          <CheckIcon className="text-white" width={40} height={40} />
        </div>
        <h1 className="text-center font-display text-[32px] font-bold sm:text-[40px]">
          Summer sessions to be discounted
        </h1>
      </div>
      <div className="flex flex-col items-center gap-4 text-lg">
        <p className="text-lg">A 20% discount will be applied to the following summer sessions:</p>
        {sessionsToDisplay?.length > 0 && (
          <div className="mx-auto w-fit items-start text-left">
            <div className="mb-5">
              <ul className="space-y-1 text-sm leading-snug">
                {sessionsToDisplay.map((session) => (
                  <li key={session.studentSessionId} className="text-lg">
                    {formatSessionSchedule(session)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        <div className="mb-5 text-center">Discounted sessions will be reflected in the session details.</div>
      </div>
      <Button
        onClick={() => {
          history.push(PATH_HUB_SESSIONS_PAGE);
        }}
        size="lg"
        appearance="reverse"
      >
        View sessions
      </Button>
      <div className="h-[150px]" />
    </Container>
  );
};

export default SummerDiscountOfferSuccess;
